import { useContext as b, createContext as v, useMemo as h, useRef as j, useEffect as A, useState as I, lazy as O } from "react";
import { jsx as s, jsxs as f } from "react/jsx-runtime";
import _, { AxiosError as E, isAxiosError as z } from "axios";
import { useTranslation as p } from "react-i18next";
import { useDispatch as B, useSelector as P, useStore as M } from "react-redux";
import { createSlice as V, createAsyncThunk as Y, combineReducers as $ } from "@reduxjs/toolkit";
const N = {
  view: "f0S1",
  manage: "f0S2",
  approve: "f0S3"
}, D = Object.values(N);
function S(e, t) {
  return t.some((r) => e.includes(r));
}
const F = v(null);
function q() {
  const e = b(F);
  if (!e)
    throw new Error("usePlanFactoryConfig must be used inside <PlanFactoryProvider>");
  return e;
}
function G() {
  const e = globalThis.crypto;
  if (e?.randomUUID) return e.randomUUID();
  if (e?.getRandomValues) {
    const t = e.getRandomValues(new Uint8Array(16)), r = Array.from(t, (n, o) => (o === 6 ? n & 15 | 64 : o === 8 ? n & 63 | 128 : n).toString(16).padStart(2, "0")).join("");
    return `${r.slice(0, 8)}-${r.slice(8, 12)}-${r.slice(12, 16)}-${r.slice(16, 20)}-${r.slice(20)}`;
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (t) => {
    const r = Math.random() * 16 | 0;
    return (t === "x" ? r : r & 3 | 8).toString(16);
  });
}
function K({
  apiBaseUrl: e,
  planServiceScope: t,
  auth: r
}) {
  const n = _.create({ baseURL: e }), o = [t];
  let i = null, c = !1;
  const y = (a) => (a ? r.getAccessToken(o, { forceRefresh: !0 }) : r.getAccessToken(o)).catch(() => null), g = () => (i || (c = !1, i = y(!0).finally(() => {
    i = null;
  })), i);
  return n.interceptors.request.use(async (a) => {
    if (a.headers.set("X-Correlation-Id", G()), !a.headers.has("Authorization")) {
      const u = await y(!1);
      u && a.headers.set("Authorization", `Bearer ${u}`);
    }
    return a;
  }), n.interceptors.response.use(void 0, async (a) => {
    if (!(a instanceof E) || a.response?.status !== 401 || !a.config)
      throw a;
    const u = a.config;
    if (!u._pfRetried) {
      const x = await g();
      if (x)
        return u._pfRetried = !0, u.headers.set("Authorization", `Bearer ${x}`), n.request(u);
    }
    throw c || (c = !0, r.onUnauthorized()), a;
  }), n;
}
const R = v(null);
function H() {
  const e = b(R);
  if (!e)
    throw new Error("usePlanFactoryApi must be used inside <PlanFactoryProvider>");
  return e;
}
function X(e) {
  const t = j(e);
  return A(() => {
    t.current = e;
  }, [e]), h(
    () => ({
      getAccessToken: (r, n) => t.current.getAccessToken(r, n),
      onUnauthorized: () => t.current.onUnauthorized(),
      logout: () => t.current.logout()
    }),
    []
  );
}
function Ne({
  children: e,
  apiBaseUrl: t,
  planServiceScope: r,
  auth: n
}) {
  const o = X(n), i = h(
    () => ({ apiBaseUrl: t, planServiceScope: r, auth: o }),
    [t, r, o]
  ), c = h(() => K(i), [i]);
  return /* @__PURE__ */ s(F.Provider, { value: i, children: /* @__PURE__ */ s(R.Provider, { value: c, children: e }) });
}
const l = "planFactory", J = {
  en: {
    home: {
      title: "Plan Factory",
      subtitle: "Build plan requests, rate sheets and price sets.",
      navUserId: "NAV user ID",
      name: "Name",
      email: "Email",
      permissions: "Permissions"
    },
    permissions: {
      f0S1: "View ({{code}})",
      f0S2: "Manage ({{code}})",
      f0S3: "Approve ({{code}})"
    },
    session: {
      loading: "Loading your NAV user…",
      errorMessage: "Your NAV user could not be loaded.",
      notLinkedTitle: "Your account is not linked to a NAV user",
      notLinkedBody: "Sign in to NAV once with this account, then reload this page.",
      signOut: "Sign out",
      noAccessTitle: "No access to Plan Factory",
      noAccessBody: "Ask your NAV administrator for a Plan Factory permission set."
    },
    ui: {
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
      noData: "No data",
      loading: "Loading…",
      errorTitle: "Something went wrong",
      retry: "Retry",
      copy: "Copy",
      copyLabel: "Copy {{label}}",
      copied: "Copied",
      copyFailed: "Copy failed",
      previous: "Previous",
      next: "Next",
      pageOf: "Page {{page}} of {{pages}}",
      rowsPerPage: "Rows per page"
    }
  }
};
function Q(e) {
  for (const [t, r] of Object.entries(J))
    e.hasResourceBundle(t, l) || e.addResourceBundle(t, l, r, !0, !1);
}
function W(...e) {
  return e.filter(Boolean).join(" ");
}
const Z = {
  solid: "bg-primary text-white hover:bg-primary-deep",
  plain: "bg-transparent text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-800",
  default: "border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700"
}, ee = {
  xs: "h-7 px-2 text-xs",
  sm: "h-8 px-3 text-sm",
  md: "h-10 px-4 text-sm",
  lg: "h-12 px-5 text-base"
};
function k({
  variant: e = "default",
  size: t = "md",
  block: r = !1,
  loading: n = !1,
  icon: o,
  type: i = "button",
  disabled: c,
  className: y,
  children: g,
  ...a
}) {
  return /* @__PURE__ */ f(
    "button",
    {
      ...a,
      type: i,
      disabled: c || n,
      "aria-busy": n || void 0,
      className: W(
        "inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-colors",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        "disabled:cursor-not-allowed disabled:opacity-60",
        Z[e],
        ee[t],
        r && "w-full",
        y
      ),
      children: [
        n ? /* @__PURE__ */ s(
          "span",
          {
            "aria-hidden": "true",
            className: "h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
          }
        ) : o,
        g
      ]
    }
  );
}
function w() {
  return p(l, { keyPrefix: "ui" }).t;
}
function te({ label: e }) {
  const t = w();
  return /* @__PURE__ */ f(
    "div",
    {
      role: "status",
      className: "flex items-center justify-center gap-2 py-10 text-gray-500 dark:text-gray-400",
      children: [
        /* @__PURE__ */ s(
          "span",
          {
            "aria-hidden": "true",
            className: "h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent"
          }
        ),
        /* @__PURE__ */ s("span", { children: e ?? t("loading") })
      ]
    }
  );
}
function re({ title: e, message: t, onRetry: r }) {
  const n = w();
  return /* @__PURE__ */ f(
    "div",
    {
      role: "alert",
      className: "flex flex-col items-center gap-2 rounded-lg bg-error-subtle px-4 py-8 text-center",
      children: [
        /* @__PURE__ */ s("p", { className: "font-semibold text-error", children: e ?? n("errorTitle") }),
        /* @__PURE__ */ s("p", { className: "text-sm text-gray-700 dark:text-gray-200", children: t }),
        r && /* @__PURE__ */ s(k, { size: "sm", onClick: r, children: n("retry") })
      ]
    }
  );
}
function C({ title: e, description: t, actions: r }) {
  return /* @__PURE__ */ f("header", { className: "mb-6 flex flex-wrap items-start justify-between gap-4", children: [
    /* @__PURE__ */ f("div", { children: [
      /* @__PURE__ */ s("h1", { className: "text-2xl font-semibold text-gray-900 dark:text-gray-50", children: e }),
      t && /* @__PURE__ */ s("p", { className: "mt-1 text-sm text-gray-500 dark:text-gray-400", children: t })
    ] }),
    r && /* @__PURE__ */ s("div", { className: "flex items-center gap-2", children: r })
  ] });
}
function T() {
  const { t: e } = p(l);
  return /* @__PURE__ */ s("main", { children: /* @__PURE__ */ s(C, { title: e("session.noAccessTitle"), description: e("session.noAccessBody") }) });
}
function ne() {
  const { t: e } = p(l), { auth: t } = q();
  return /* @__PURE__ */ s("main", { children: /* @__PURE__ */ s(
    C,
    {
      title: e("session.notLinkedTitle"),
      description: e("session.notLinkedBody"),
      actions: /* @__PURE__ */ s(k, { variant: "default", onClick: () => void t.logout(), children: e("session.signOut") })
    }
  ) });
}
const m = "planFactory", L = { status: "idle", user: null };
function se(e) {
  if (typeof e != "object" || e === null || typeof e.navUserId != "number")
    throw new Error("Unexpected /v1/me response shape");
  const t = e, r = t.permissions, n = Array.isArray(r) && r.every((o) => typeof o == "string");
  return {
    navUserId: t.navUserId,
    firstName: t.firstName ?? "",
    lastName: t.lastName ?? "",
    email: t.email ?? "",
    permissions: n ? [...new Set(r)] : []
  };
}
const d = Y(
  "planFactory/session/fetchCurrentUser",
  async (e, { rejectWithValue: t }) => {
    try {
      const r = await e.get("/v1/me");
      return se(r.data);
    } catch (r) {
      return t(
        z(r) && r.response?.status === 403 ? "notLinked" : "failed"
      );
    }
  },
  {
    condition: (e, { getState: t }) => t()[m]?.session?.status !== "loading"
  }
), oe = V({
  name: "planFactory/session",
  initialState: L,
  reducers: {},
  extraReducers: (e) => {
    e.addCase(d.pending, () => ({ status: "loading", user: null })).addCase(d.fulfilled, (t, r) => ({
      status: "ready",
      user: r.payload
    })).addCase(d.rejected, (t, r) => ({
      status: r.payload ?? "failed",
      user: null
    }));
  }
}), ae = oe.reducer, ie = Object.freeze([]);
function U(e) {
  return e[m]?.session ?? L;
}
function ce(e) {
  return U(e).user?.permissions ?? ie;
}
function ue({ children: e }) {
  const { t } = p(l), r = H(), n = B(), { status: o, user: i } = P(U);
  switch (A(() => {
    o === "idle" && n(d(r));
  }, [o, r, n]), o) {
    case "notLinked":
      return /* @__PURE__ */ s(ne, {});
    case "failed":
      return /* @__PURE__ */ s(
        re,
        {
          message: t("session.errorMessage"),
          onRetry: () => void n(d(r))
        }
      );
    case "ready":
      return i && S(i.permissions, D) ? e : /* @__PURE__ */ s(T, {});
    default:
      return /* @__PURE__ */ s(te, { label: t("session.loading") });
  }
}
const le = $({ session: ae });
function de(e) {
  return typeof e.injectReducer == "function";
}
function Se({ children: e }) {
  const t = M(), { i18n: r } = p();
  return I(() => {
    if (!de(t))
      throw new Error("PlanFactoryModuleGate needs a host store with injectReducer(key, reducer)");
    return m in t.getState() || t.injectReducer(m, le), Q(r), !0;
  }), /* @__PURE__ */ s("div", { className: "pf-root", children: /* @__PURE__ */ s(ue, { children: e }) });
}
function fe({ authority: e, children: t }) {
  const r = P(ce);
  return e.length > 0 && !S(r, e) ? /* @__PURE__ */ s(T, {}) : t;
}
function pe({ load: e, ...t }) {
  const r = O(
    () => e().then(({ default: n }) => ({
      default: function() {
        return /* @__PURE__ */ s(fe, { authority: t.authority, children: /* @__PURE__ */ s(n, {}) });
      }
    }))
  );
  return { ...t, component: r };
}
const { view: ye, manage: me, approve: ge } = N, Fe = [
  pe({
    key: "planFactory.home",
    path: "",
    load: () => import("./HomePage-n-Ylzuib.js"),
    authority: [ye, me, ge],
    meta: { titleKey: "home.title" }
  })
];
export {
  D as A,
  l as P,
  C as a,
  N as b,
  m as c,
  Se as d,
  Ne as e,
  ce as f,
  Fe as p,
  U as s,
  q as u
};
//# sourceMappingURL=index-CI3CPUDy.js.map
